var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConcierge = function SvgConcierge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.302 20.7V20h10.4v.7zm1-2.2q0-1.65 1.112-2.85a4.03 4.03 0 0 1 2.738-1.325v-.35q0-.125.1-.237a.32.32 0 0 1 .25-.113q.125 0 .237.113a.34.34 0 0 1 .113.237v.35a4.03 4.03 0 0 1 2.737 1.325q1.113 1.2 1.113 2.85zm.775-.7h6.825a3.5 3.5 0 0 0-1.188-2.025q-.937-.8-2.212-.8t-2.225.8a3.5 3.5 0 0 0-1.2 2.025M2.352 11.6V4.3h3.4v1.25l7.8-2.3 6.7 2.1v.3q0 .75-.638 1.3a2.24 2.24 0 0 1-1.512.55h-2.7v.45q0 .475-.35.875t-.8.575l-6 2.2zm.7-.7h2V5h-2zm2.7 0h2.4l6.05-2.225a.72.72 0 0 0 .5-.7V7.5h-1.975l-2.925.975-.25-.675 3.1-1h5.45q.375 0 .837-.225a.98.98 0 0 0 .563-.725l-6-1.85-7.75 2.3z"
  })));
};
export default SvgConcierge;